module.exports = __webpack_public_path__ + "static/media/map.938b9611.png";